<template>
  <v-text-field
    class="textFiled"
    @keydown.space="preventLeadingSpace"
    density="compact"
    :disabled="showReadOnly"
    :placeholder="placeholder"
    :rules="rules"
    variant="outlined"
    :type="type"
    v-model="localValue"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>
<script>
export default {
  name: "TextFieldComponent",
  props: {
    modelValue:   { default: null },
    showReadOnly: { type: Boolean, default: false },
    placeholder:  { type: String,  default: "" },
    rules:        { type: Array,   default: () => [] },
    type:         { type: String,  default: "text" },
  },
  emits: ["update:modelValue"],
  computed: {
    localValue: {
      get() { return this.modelValue; },
      set(val) { this.$emit("update:modelValue", val); },
    },
  },
  methods: {
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] === " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
  },
};
</script>
